module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.loaded == 'true') ? _c('span', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("PODCAST")]), _vm._v(" "), (_vm.loaded_categorias == 'true') ? _c('ul', {
    staticClass: "col-xs-12 filtro"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'archive_podcast'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tTodos\n\t\t\t\t\t")])], 1), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('li', {
      staticClass: "nonactive",
      attrs: {
        "elpodcast": categoria.slug
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'interna_podcast',
          params: {
            name: categoria.slug
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(categoria.name) + "\n\t\t\t\t\t")])], 1)
  })], 2) : _vm._e()])]), _vm._v(" "), (_vm.loaded_posts == 'true') ? _c('div', {
    staticClass: "col-xs-12 block reproductor"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rss-botones"
  }, [(_vm.LaCat.categoria_meta.hasOwnProperty('url_google_podcast')) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.LaCat.categoria_meta.url_google_podcast
    }
  }, [_c('img', {
    staticStyle: {
      "height": "2%",
      "width": "2%"
    },
    attrs: {
      "src": _vm.theme_url + '/html/assets/img/btn-googlepodcast.png'
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.LaCat.categoria_meta.hasOwnProperty('url_itunes')) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.LaCat.categoria_meta.url_itunes
    }
  }, [_c('img', {
    staticStyle: {
      "height": "2%",
      "width": "2%"
    },
    attrs: {
      "src": _vm.theme_url + '/html/assets/img/btn-itunespodcast.jpg'
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.LaCat.categoria_meta.hasOwnProperty('url_ivoox')) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.LaCat.categoria_meta.url_ivoox
    }
  }, [_c('img', {
    staticStyle: {
      "height": "2%",
      "width": "2%"
    },
    attrs: {
      "src": _vm.theme_url + '/html/assets/img/btn-ivoox.png'
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.LaCat.categoria_meta.hasOwnProperty('url_spotify')) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.LaCat.categoria_meta.url_spotify
    }
  }, [_c('img', {
    staticStyle: {
      "height": "2%",
      "width": "2%"
    },
    attrs: {
      "src": _vm.theme_url + '/html/assets/img/btn-spotify.png'
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "player__playlist"
  }, [_c('div', {
    staticClass: "compartir__player"
  }, [_c('button', [_c('i', {
    staticClass: "icon share"
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + _vm.LaCat.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.LaCat.link + '&text=' + _vm.LaCat.name,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "itemwa"
  }, [_c('a', {
    attrs: {
      "href": 'whatsapp://send?text=' + _vm.LaCat.link
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])])])]), _vm._v(" "), _c('a', {
    staticClass: "fav__player",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon star",
    attrs: {
      "programa": _vm.LaCat.id
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "playlist"
  }, _vm._l((_vm.posts), function(audio) {
    return (audio.better_featured_image != null) ? _c('li', {
      staticClass: "col-xs-12 npd",
      attrs: {
        "data-cover": audio.better_featured_image.media_details.sizes['306x307'].source_url,
        "data-descripcion": audio.soloexcerpt
      }
    }, [_c('a', {
      attrs: {
        "href": audio.post_meta_fields._enclosure_mp3
      }
    }, [_c('span', {
      staticClass: "titulo",
      domProps: {
        "innerHTML": _vm._s(audio.title.rendered)
      }
    }), _vm._v(" "), (audio.acf.locutor.length > 0) ? _c('span', {
      staticClass: "autor"
    }, [_vm._v(_vm._s(audio.acf.locutor[0].post_title))]) : _c('span', {
      staticClass: "autor"
    }, [_vm._v("---")]), _vm._v(" "), _c('span', {
      staticClass: "fecha",
      domProps: {
        "innerHTML": _vm._s(audio.fechaconformatocorto)
      }
    }), _vm._v(" "), (audio.post_meta_fields.hasOwnProperty('_duration')) ? _c('span', {
      staticClass: "duracion"
    }, [_vm._v(_vm._s(audio.post_meta_fields._duration.duration))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "descarga"
    }, [_c('button', {
      attrs: {
        "type": "button"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tDescargar\n\t\t\t\t\t\t\t\t\t\t")])])])]) : _vm._l((_vm.posts), function(audio) {
      return _c('li', {
        staticClass: "col-xs-12 npd",
        attrs: {
          "data-cover": _vm.theme_url + 'assets/img/imgplay.jpg',
          "data-descripcion": audio.soloexcerpt
        }
      }, [_c('a', {
        attrs: {
          "href": audio.post_meta_fields._enclosure_mp3
        }
      }, [_c('span', {
        staticClass: "titulo",
        domProps: {
          "innerHTML": _vm._s(audio.title.rendered)
        }
      }), _vm._v(" "), (audio.acf.locutor.length > 0) ? _c('span', {
        staticClass: "autor"
      }, [_vm._v(_vm._s(audio.acf.locutor[0].post_title))]) : _c('span', {
        staticClass: "autor"
      }, [_vm._v("---")]), _vm._v(" "), _c('span', {
        staticClass: "fecha",
        domProps: {
          "innerHTML": _vm._s(audio.fechaconformatocorto)
        }
      }), _vm._v(" "), (audio.post_meta_fields.hasOwnProperty('_duration')) ? _c('span', {
        staticClass: "duracion"
      }, [_vm._v(_vm._s(audio.post_meta_fields._duration.duration))]) : _vm._e()])])
    })
  }))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.totalPages > 1) ? _c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    attrs: {
      "id": "rtShowFirst"
    },
    on: {
      "click": function($event) {
        _vm.rtShowFirst()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t««\n\t\t\t\t\t")]), _vm._v(" "), (_vm.showPrev == 'true') ? _c('li', {
    attrs: {
      "id": "rtShowPrev"
    },
    on: {
      "click": function($event) {
        _vm.rtShowPrev()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t«\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.currentPage) + " - " + _vm._s(_vm.totalPages) + "\n\t\t\t\t\t")]), _vm._v(" "), (_vm.showNext == 'true') ? _c('li', {
    attrs: {
      "id": "rtShowNext"
    },
    on: {
      "click": function($event) {
        _vm.rtShowNext()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t»\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('li', {
    attrs: {
      "id": "rtShowLast"
    },
    on: {
      "click": function($event) {
        _vm.rtShowLast()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t»»\n\t\t\t\t\t")])])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f40b73a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/new_interna_podcast.vue
// module id = 137
// module chunks = 0